module.exports = __webpack_public_path__ + "static/media/nico-robin-icon.b9d85f4d.png";